import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid, Button, Stack, Box, 
  Paper, Typography, Badge,  IconButton
} from '@mui/material';

import {
  selectRequestIds, 
  selectRequestById
} from '../../store/requestSlice'



import {  parse, formatDistanceToNow, } from 'date-fns'

import {useNavigate} from 'react-router-dom' 

import {usePlayContext} from '../../utils/PlayContext';


import Tooltip from '@mui/material/Tooltip';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';

import WalkinIcon from '@mui/icons-material/Snowshoeing';

import ApproveIcon from '@mui/icons-material/Done';
import DenyIcon from '@mui/icons-material/Close';

import CourierIcon from '@mui/icons-material/DeliveryDining';
//import PersonIcon from '@mui/icons-material/Person';
import PersonIcon from '@mui/icons-material/EmojiPeople';



const RequestItem = ({id})=>
{
  const dispatch = useDispatch()
  const it = useSelector(selectRequestById(id));
  const navigate = useNavigate()
    

  let createdTm = parse(it.createdTm, 'dd/MM/yyyy HH:mm:ss', new Date())
  createdTm = formatDistanceToNow (createdTm)

  const canDecide = (it.status==='INIT' && (it.type==='Courier'||it.type==='Visitor'))

  
    let displayedStatusColor= '#0000DD'

    if (it.status==='APPROVED')
    {
        displayedStatusColor='success.main'
    }
    else if (it.status==='REJECTED' ) 
    {
        displayedStatusColor='warning.main'
    }

    let iconBgColor= it.status==='PENDING' ? 'primary.main' :'success.main'

   if (it.status==='REJECTED') iconBgColor='light'




  return(
    <>
      <Card sx={{width:'100%', border:1}}
        >
          <CardHeader
            sx={{my:0, py:0}}
            avatar={
              <Avatar size='small' sx={{  width:32, height:32}}>
                {
                    it.type==='Visitor' &&
                    <PersonIcon size='small' sx={{ bgcolor: `${iconBgColor}` , width:32, height:32}}/>
                }
                {
                    it.type==='Courier' &&
                    <CourierIcon size='small' sx={{ bgcolor: `${iconBgColor}` , width:32, height:32}}/>
                }
              </Avatar>
            }
            action={
                  <Typography  sx={{m:0,p:0}} variant='body1'><small>{createdTm} <i>Ago</i></small></Typography>
             }
            title={<Typography sx={{m:0,p:0}}
              fontWeight={it.status==='PENDING' ? 450:350}
              variant='subtitle1'>{it.reason}</Typography>}

            subheader={<Typography  variant='body2'><small>
              <i>Walk-in&nbsp;&nbsp;</i>
              {it.type}</small></Typography>}
         />
         <CardContent sx={{p:0,mx:1}}>

              
          <Box sx={{ display: {xs:'block',md:'flex'}, py: 0, my:0, px:2,bgcolor: 'background.paper', }}  >

            <Box sx={{p:0,ml:2,flexGrow:1}}>
              <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 
                  <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'>
                          <strong>{it.type}&nbsp;Name :&nbsp;</strong>{it.name}
                        </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Phone :&nbsp;</strong>{it.phoneDisplay}
                        </Typography>
                   </Grid>
                   
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Email :&nbsp;</strong>{ it.email}
                        </Typography>
                   </Grid>
                  
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Organization :&nbsp;</strong>{it.company}
                        </Typography>
                   </Grid>
                </Grid>
                <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 

                    <Grid item xs={12} md={6} lg={3}>
                          <Typography variant='body2'
                            > <strong>Request Time :&nbsp;</strong>{it.startTm}
                          </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          >  <strong>Location :&nbsp;</strong>{it.location}
                        </Typography>
                   </Grid>
                   {/**                    <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          > <strong>Remarks :&nbsp;</strong>{it.remarks}
                        </Typography>
                   </Grid>
                   */}
                    <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2' sx={{color:`${displayedStatusColor}`}}

                            > <strong>Status :&nbsp;</strong>
                            {it.status}
                        </Typography>
                   </Grid>
                </Grid>
                <Grid  container  columns={12}  spacing={1}    sx={{m:0, p:0,}}  > 


                   
                   {it.status!=='PENDING' &&
                   <>
                   <Grid item xs={12} md={6} lg={3}>
                        <Typography variant='body2'
                          >  <strong>Floor :&nbsp;</strong>{it.floor}
                        </Typography>
                  </Grid>
                    <Grid item xs={12} md={6} lg={9}>
                          <Typography variant='body2'
                            > <strong>Host Remarks :&nbsp;</strong>{it.hostRemarks}
                          </Typography>
                    </Grid>
                    
                   </>
                  
                  }
              </Grid>
              
              </Box>
          </Box>
         </CardContent>
         { it.status==='PENDING' &&

            <CardActions sx={{px:2, mx:0,pt:0, mb:0, }}>
                  <Box sx={{display:'flex', justifyContent:'space-around', flexDirection:'row', width:'100%'}}>
                  <Button variant="outlined" 
                    color='success'
                onClick ={ (e)=>{navigate('/request/approve/'+it.id);} }
              > <ApproveIcon/>Approve
            </Button>



            <Button variant="outlined" 
              color='error'
                //variant="contained" color='error'  
                //disabled = {status==='success'}
                onClick ={ (e)=>{navigate('/request/deny/'+it.id);} }
              > <DenyIcon/>Reject
            </Button>
            </Box>
                 

            </CardActions>

              }

      </Card>
      
  
    </>
  );

}

const PendingRequestListPage = () => {

  const {
    setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    setTenantLogo
  }=usePlayContext()


    const requestIds =  useSelector(selectRequestIds)


  useEffect(()=>{
      setErrorMessage('')
      setErrorTitle('')
      setAppTitle(['Pending Walk-in Requests'])

      return ()=>{
        setErrorMessage('')
        setErrorTitle('')          
      }
  },[])

   
  return (
    <Stack sx={{ width: '100%' , mt:1}} spacing={2}>
    {
      requestIds.map(  id=><RequestItem key={id} id={id}/>)
    }
</Stack>
  );
};

export default PendingRequestListPage;
